import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ProjectsPageRequest } from '../model/management-config/projectPageRequest';
import { CreateProjectRequest, GetAllClientsNames, ProjectManagement, UpdateProjectRequest } from '../model/management-config/projectManagement';


@Injectable({
  providedIn: 'root'
})
export class ProjectManagementService{

  private baseUrl: string;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  public getAllClientsNames(): Observable<any> {
    console.log("Get all Clients ..");
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<any>(this.baseUrl.concat("/clients"), { headers: headers });
  }

  public getProjectsList(request: ProjectsPageRequest): Observable<any> {
    console.log("Get all Client Management list..");
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<ProjectsPageRequest>(this.baseUrl.concat("/projects"), request, {headers: headers});
  }

  public addProjectRequests(project:CreateProjectRequest): Observable<any> {
    console.log("Adding New Project ::  Adding data..");
    console.log(project);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<CreateProjectRequest>(this.baseUrl.concat("/projects/create"), project, { headers: headers });
  }

  public editProjectRequests(project:UpdateProjectRequest): Observable<any> {
    console.log("Edit Projects Data :: Saving data..");
    console.log(project);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<UpdateProjectRequest>(this.baseUrl.concat("/projects/update"), project, { headers: headers });
  }

}
